module.exports = __webpack_public_path__ + "img/leaf-fluttering-in-wind.67f5be55.png";